import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const PublicRoute = React.memo(({ children }) => {
  const { token, loading, userType } = useUser();

  if (loading) {
    return <div>Loading...</div>;
  }

  // Only redirect to dashboard if explicitly trying to access login while authenticated
  if (token && window.location.pathname === '/login') {
    return <Navigate to={userType === 'admin' ? '/admin' : '/dashboard'} replace />;
  }

  return <>{children}</>;
});

PublicRoute.displayName = 'PublicRoute';

export default PublicRoute; 